import {
  FC,
  ReactNode,
  createContext,
  useState,
  useEffect,
  useRef,
  Dispatch,
  MutableRefObject,
} from "react"
import { DELIVERY_STATES, EVENTS } from "./constants"
import { useLocalStorage } from "react-use"

export const GlobalStateContext = createContext<IGlobalState>(
  {} as IGlobalState
)

interface GlobalStateProps {
  children: ReactNode
}

type ScrollRestorationRoutes = Record<string, number>

export interface IGlobalState {
  apps: any
  showSettingsMenu: boolean
  setShowSettingsMenu: Dispatch<boolean>
  showBottomNavBar: boolean
  setShowBottomNavBar: Dispatch<boolean>
  shouldScroll: boolean
  setShouldScroll: Dispatch<boolean>
  tabId: string | undefined
  setTabId: Dispatch<string | undefined>
  currentModal: string | null
  currentModalParams: any
  openModal: (modalName: string, params: any) => void
  closeModal: () => void
  scrollContainerRef: MutableRefObject<any>
  scrollRestorationRoutes: ScrollRestorationRoutes
  setScrollRestorationRoute: (pathname: string, scrollTop: number) => void
  mainFTUECompleted: boolean | undefined
  setMainFTUECompleted: Dispatch<boolean>
}

export const GlobalState: FC<GlobalStateProps> = ({ children }) => {
  const [apps, setApps] = useState<any>({})
  const [showSettingsMenu, setShowSettingsMenu] = useState(false)
  const [showBottomNavBar, setShowBottomNavBar] = useState(true)
  const [shouldScroll, setShouldScroll] = useState(true)
  const scrollContainerRef = useRef()
  const [scrollRestorationRoutes, setScrollRestorationRoutes] =
    useState<ScrollRestorationRoutes>({})
  const [mainFTUECompleted, setMainFTUECompleted] = useLocalStorage(
    "mainFTUECompleted",
    false
  )
  const [currentModal, setCurrentModal] = useState<string | null>(null)
  const [currentModalParams, setCurrentModalParams] = useState<any>(null)
  const [tabId, setTabId] = useState<string | undefined>()

  const value = {
    apps,

    showSettingsMenu,
    setShowSettingsMenu,

    showBottomNavBar,
    setShowBottomNavBar,

    shouldScroll,
    setShouldScroll,

    tabId,
    setTabId,

    currentModal,
    currentModalParams,
    // TODO: do we use this?
    openModal(modalName: string, params: any) {
      setCurrentModal(modalName)
      setCurrentModalParams(params)
    },
    closeModal() {
      setCurrentModal(null)
      setCurrentModalParams(null)
    },

    // TODO: Why dis broken???
    scrollContainerRef,
    scrollRestorationRoutes,
    setScrollRestorationRoute(pathname: string, scrollTop: number) {
      setScrollRestorationRoutes(prev => {
        prev = {
          ...prev,
          [pathname]: scrollTop,
        }
        if (!scrollTop) delete prev[pathname]
        return prev
      })
    },

    mainFTUECompleted,
    setMainFTUECompleted,
  }

  useEffect(() => {
    function onDeliveriesStatus(e: any) {
      const { deliveries } = e.detail

      setApps((prev: any) => {
        const packages: any = {}
        deliveries.forEach((delivery: any) => {
          const { packageName, versionCode, status } = delivery

          const { type: state, progress } = status

          if (state === DELIVERY_STATES.failed) {
            delete prev[packageName]
            return
          }

          const { totalSizeInBytes, downloadedSizeInBytes } = progress || {}
          const progressPcent: number = progress
            ? (downloadedSizeInBytes / totalSizeInBytes) * 100
            : 0

          packages[packageName] = {
            ...prev[packageName],
            deliveryProcessState: state,
            deliveryProcessVersionCode: versionCode,
            progress: progressPcent,
          }
        })

        const newState = {
          ...prev,
          ...packages,
        }
        console.log("newDeliveriesState", JSON.stringify(newState))
        return newState
      })
    }

    function onPackagesStatus(e: any) {
      const { packages } = e.detail

      setApps((prev: any) => {
        const packagesObj: any = {}

        packages.forEach(({ packageName, versionCode }: any) => {
          packagesObj[packageName] = {
            deliveryProcessState: DELIVERY_STATES.installed,
            installedVersionCode: versionCode,
          }
        })

        const newState = {
          ...packagesObj,
        }
        console.log("newPackagesState", JSON.stringify(newState))
        return newState
      })
    }

    function onModalOpen(e: any) {
      const { modalName, params } = e.detail
      setCurrentModal(modalName)
      setCurrentModalParams(params)
    }

    function onModalClose() {
      setCurrentModal(null)
      setCurrentModalParams(null)
    }

    window.addEventListener(EVENTS.DELIVERIES_STATUS, onDeliveriesStatus)
    window.addEventListener(EVENTS.PACKAGES_STATUS, onPackagesStatus)
    window.addEventListener(EVENTS.MODAL_OPEN, onModalOpen)
    window.addEventListener(EVENTS.MODAL_CLOSE, onModalClose)

    return () => {
      window.removeEventListener(EVENTS.DELIVERIES_STATUS, onDeliveriesStatus)
      window.removeEventListener(EVENTS.PACKAGES_STATUS, onPackagesStatus)
      window.removeEventListener(EVENTS.MODAL_OPEN, onModalOpen)
      window.removeEventListener(EVENTS.MODAL_CLOSE, onModalClose)
    }
  }, [])

  return (
    <GlobalStateContext.Provider value={value}>
      {children}
    </GlobalStateContext.Provider>
  )
}
